<div class="modal-backdrop">
  <div class="modal-container">
    <div class="modal">
      <div class="modal-header">
        <h3 class="modal-title">Detalhes do Pagamento #{{ data.payment.id }}</h3>
      </div>

      <mat-dialog-content class="modal-body">
        <div class="payment-details">
          <!-- Informações do Pagamento -->
          <div class="info-section">
            <div class="title-section">Informações Gerais</div>
            
            <div class="info-row">
              <span class="info-label">ID:</span>
              <span class="info-separator"></span>
              <span class="info-data">{{ data.payment.id }}</span>
            </div>
            
            <div class="info-row">
              <span class="info-label">ID do Plano:</span>
              <span class="info-separator"></span>
              <span class="info-data">{{ data.payment.accessPlanId || '—' }}</span>
            </div>
            
            <div class="info-row">
              <span class="info-label">Método:</span>
              <span class="info-separator"></span>
              <span class="info-data">{{ data.payment.method | enumDescription }}</span>
            </div>
            
            <div class="info-row">
              <span class="info-label">Status:</span>
              <span class="info-separator"></span>
              <span class="badge" [ngClass]="getStatusBadgeClass(data.payment.status)">
                {{ data.payment.status | enumDescription }}
              </span>
            </div>
            
            <div class="info-row">
              <span class="info-label">Número de Parcelas:</span>
              <span class="info-separator"></span>
              <span class="info-data">{{ data.payment.numberOfInstallments || 1 }}</span>
            </div>
            
            <div class="info-row">
              <span class="info-label">Criado em:</span>
              <span class="info-separator"></span>
              <span class="info-data">{{ formatDate(data.payment.createdAt) }}</span>
            </div>
            
            <div class="info-row">
              <span class="info-label">Atualizado em:</span>
              <span class="info-separator"></span>
              <span class="info-data">{{ formatDate(data.payment.updatedAt) }}</span>
            </div>
          </div>

          <!-- Valor Total -->
          <div class="card card-dark total-section">
            <div class="total-content">
              <div>
                <strong>Valor Total</strong>
                <p>Valor total do pagamento</p>
              </div>
              <div class="total-value">
                {{ formatPrice(data.payment.totalAmount) }}
              </div>
            </div>
          </div>

          <mat-divider></mat-divider>

          <!-- Progresso de Parcelas -->
          <div class="progress-section">
            <div class="title-section">Progresso de Parcelas</div>
            <div class="progress-container">
              <div class="progress-header">
                <span class="progress-label">
                  {{ getPaidInstallmentsCount() }} de {{ data.payment.numberOfInstallments || 1 }} parcelas pagas
                </span>
                <span class="progress-percentage">{{ getProgressPercentage().toFixed(0) }}%</span>
              </div>
              <mat-progress-bar 
                mode="determinate" 
                [value]="getProgressPercentage()"
                color="primary">
              </mat-progress-bar>
            </div>
          </div>

          <mat-divider></mat-divider>

          <!-- PARCELAS -->
          <div class="installments-section">
            <div class="title-section">Parcelas ({{ getInstallmentsCount() }})</div>

            <div *ngIf="data.payment.installments && data.payment.installments.length > 0; else noInstallments">
              <table mat-table [dataSource]="data.payment.installments" class="installments-table">
                <ng-container matColumnDef="number">
                  <th mat-header-cell *matHeaderCellDef>Parcela</th>
                  <td mat-cell *matCellDef="let installment">{{ installment.installmentNumber }}</td>
                </ng-container>

                <ng-container matColumnDef="amount">
                  <th mat-header-cell *matHeaderCellDef>Valor</th>
                  <td mat-cell *matCellDef="let installment">{{ formatPrice(installment.amount) }}</td>
                </ng-container>

                <ng-container matColumnDef="dueDate">
                  <th mat-header-cell *matHeaderCellDef>Vencimento</th>
                  <td mat-cell *matCellDef="let installment">{{ formatDate(installment.dueDate) }}</td>
                </ng-container>

                <ng-container matColumnDef="paidAt">
                  <th mat-header-cell *matHeaderCellDef>Pago em</th>
                  <td mat-cell *matCellDef="let installment">{{ formatDate(installment.paidAt) }}</td>
                </ng-container>

                <ng-container matColumnDef="status">
                  <th mat-header-cell *matHeaderCellDef>Status</th>
                  <td mat-cell *matCellDef="let installment">
                    <span class="badge" [ngClass]="getStatusBadgeClass(installment.status)">
                      {{ installment.status | enumDescription }}
                    </span>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="['number','amount','dueDate','paidAt','status']"></tr>
                <tr mat-row *matRowDef="let row; columns: ['number','amount','dueDate','paidAt','status'];"></tr>
              </table>
            </div>

            <ng-template #noInstallments>
              <p class="empty-message">Nenhuma parcela registrada</p>
            </ng-template>
          </div>
        </div>
      </mat-dialog-content>

      <mat-dialog-actions class="modal-footer">
        <button mat-stroked-button (click)="onClose()" class="btn btn-ghost">
          <mat-icon>close</mat-icon>
          Fechar
        </button>
      </mat-dialog-actions>
    </div>
  </div>
</div>
